var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"chartsWrapper",staticClass:"d-flex justify-center charts-multiples-pie-charts"},_vm._l((_vm.data),function(chart,index){return _c('canvas',{key:index,ref:"chartCanvas",refInFor:true})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }